import type * as React from 'react';
import { getIntrinsicElementProps, slot } from '@fluentui/react-components';
import type {
  GroundingCommandBarActionsProps,
  GroundingCommandBarActionsState,
} from './GroundingCommandBarActions.types';

// If you add JSX to this file, be sure to change the file type to .tsx

/**
 * Create the state required to render GroundingCommandBarActions.
 *
 * The returned state can be modified with hooks such as useGroundingCommandBarActionsStyles_unstable,
 * before being passed to renderGroundingCommandBarActions_unstable.
 *
 * @param props - props from this instance of GroundingCommandBarActions
 * @param ref - reference to root HTMLElement of GroundingCommandBarActions
 */
export const useGroundingCommandBarActions_unstable = (
  props: GroundingCommandBarActionsProps,
  ref: React.Ref<HTMLSpanElement>,
): GroundingCommandBarActionsState => {
  return {
    components: {
      root: 'span',
    },
    root: slot.always(
      getIntrinsicElementProps('span', {
        ref,
        ...props,
      }),
      { elementType: 'span' },
    ),
  };
};
